import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGurdService {
  constructor(private tokenService: TokenService, private route: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | boolean {
    if (this.tokenService.getToken() && this.tokenService.getUserId()) {
      return true;
    }
    else {
      this.route.navigate(['/login']);
      return false;
    }
  }
}
